<template>
  <div class="container" style="margin-bottom: 10px">
    <div class="card" style="padding: 16px">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <img
            :src="jelouLogo"
            alt="Jelou"
            class="jelou-logo"
            width="48"
            height="48"
          />
          <div>
            <h5 style="margin: 0">Jelou — prueba de HSM</h5>
            <p style="margin: 0; font-size: 12px; color: #7c7c7c">
              Envío vía <code>consultasV2</code> (<code>/testing/Jelou/SendHsm</code>). Las credenciales
              quedan en el servidor. Teléfonos: código de país, solo dígitos, sin
              <code>+</code> (se normalizan al enviar).
            </p>
          </div>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <button class="btn btn-outline-secondary btn-sm" type="button" @click="resetForm">
            Reset
          </button>
          <button class="btn btn-success btn-sm" type="button" :disabled="sending" @click="onEnviar">
            {{ sending ? "Enviando..." : "Enviar" }}
          </button>
        </div>
      </div>

      <hr style="margin: 12px 0" />

      <div class="row">
        <div class="col-12 col-md-6">
          <label class="form-label">URL del endpoint (opcional)</label>
          <input
            v-model="endpointUrl"
            class="form-control"
            type="text"
            autocomplete="off"
            :placeholder="defaultProxyPlaceholder"
          />
          <small style="color: #7c7c7c">
            Vacío = mismo host que el resto de la app (emulador o prod).
          </small>
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">type</label>
          <input v-model="form.type" class="form-control" type="text" placeholder="text" />
        </div>
        <div class="col-12 col-md-3">
          <label class="form-label">language</label>
          <input v-model="form.language" class="form-control" type="text" placeholder="es" />
        </div>
      </div>

      <div class="row" style="margin-top: 4px">
        <div class="col-12 col-md-6">
          <label class="form-label">elementName <span class="text-danger">*</span></label>
          <input
            v-model.trim="form.elementName"
            class="form-control"
            type="text"
            autocomplete="off"
            placeholder="Nombre del template HSM"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">Destinos (teléfonos WhatsApp) <span class="text-danger">*</span></label>
          <textarea
            v-model="destinationsRaw"
            class="form-control"
            rows="3"
            spellcheck="false"
            placeholder="Uno por línea o coma. Ej: 5939XXXXXXXX o +593 9X XX XX XX (se quita + y espacios)"
          />
        </div>
      </div>

      <div class="row" style="margin-top: 8px">
        <div class="col-12 col-md-6">
          <label class="form-label">mediaUrl</label>
          <input v-model.trim="form.mediaUrl" class="form-control" type="text" autocomplete="off" />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">filename</label>
          <input v-model.trim="form.filename" class="form-control" type="text" autocomplete="off" />
        </div>
      </div>

      <div class="row" style="margin-top: 8px">
        <div class="col-12 col-md-6">
          <label class="form-label">campaignId</label>
          <input v-model.trim="form.campaignId" class="form-control" type="text" autocomplete="off" />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">expirationTime</label>
          <input v-model.trim="form.expirationTime" class="form-control" type="text" autocomplete="off" />
        </div>
      </div>

      <div class="row" style="margin-top: 12px">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <h6 style="margin: 0">parameters</h6>
            <button class="btn btn-outline-primary btn-sm" type="button" @click="addParam">
              + Agregar
            </button>
          </div>
          <p style="margin: 6px 0 0 0; font-size: 12px; color: #7c7c7c">
            Valores en el orden que espera el template ({{ form.parameters.length }} ítem(s)).
          </p>
          <div
            v-for="(p, idx) in form.parameters"
            :key="`p-${idx}`"
            class="row align-items-center"
            style="margin-top: 8px"
          >
            <div class="col">
              <input
                v-model="form.parameters[idx]"
                class="form-control"
                type="text"
                :placeholder="`Parámetro ${idx + 1}`"
              />
            </div>
            <div class="col-auto">
              <button
                class="btn btn-outline-danger btn-sm"
                type="button"
                title="Quitar"
                @click="removeParam(idx)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
          <div v-if="form.parameters.length === 0" class="text-muted" style="margin-top: 8px; font-size: 13px">
            Sin parámetros (vacío se envía como <code>[]</code>).
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 16px">
        <div class="col-12">
          <label class="form-label">Payload (JSON)</label>
          <textarea
            class="form-control"
            :value="payloadPreview"
            rows="10"
            readonly
            spellcheck="false"
          />
        </div>
      </div>

      <div v-if="lastResult" style="margin-top: 12px">
        <small style="color: #7c7c7c">Última respuesta</small>
        <div class="card" style="padding: 10px; border: 1px solid #eee; margin-top: 6px">
          <div class="d-flex gap-2 flex-wrap">
            <span class="badge" :class="lastResult.ok ? 'bg-success' : 'bg-danger'">
              {{ lastResult.ok ? "OK" : "ERROR" }}
            </span>
            <span class="badge bg-secondary">HTTP {{ lastResult.status }}</span>
          </div>
          <pre
            style="margin: 8px 0 0 0; white-space: pre-wrap; word-break: break-word"
          >{{ lastResult.body }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getConsultasApiV1BaseURL } from "@/store/axios";
import jelouLogo from "@/assets/img/Saludsa/jelou.svg";

export default {
  name: "JelouAdmin",
  data() {
    return {
      jelouLogo,
      endpointUrl: "",
      destinationsRaw: "",
      form: this.getDefaultForm(),
      payloadPreview: "",
      sending: false,
      lastResult: null,
    };
  },
  computed: {
    defaultJelouUrl() {
      const base = getConsultasApiV1BaseURL();
      const normalized = base.endsWith("/") ? base : `${base}/`;
      return `${normalized}testing/Jelou/SendHsm`;
    },
    defaultProxyPlaceholder() {
      return `Vacío → ${this.defaultJelouUrl}`;
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.refreshPayloadPreview();
      },
    },
    destinationsRaw() {
      this.refreshPayloadPreview();
    },
  },
  mounted() {
    this.refreshPayloadPreview();
  },
  methods: {
    getDefaultForm() {
      return {
        elementName: "",
        type: "text",
        language: "",
        mediaUrl: "",
        filename: "",
        campaignId: "",
        expirationTime: "",
        parameters: [],
      };
    },
    parseDestinations(raw) {
      const s = String(raw || "").trim();
      if (!s) return [];
      const byComma = s.includes(",") && !s.includes("\n");
      if (byComma) {
        return s
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean);
      }
      return s
        .split(/\r?\n/)
        .map((x) => x.trim())
        .filter(Boolean);
    },
    /** Same rules as backend: country code, no +, digits only. */
    normalizeJelouDestination(raw) {
      const trimmed = String(raw ?? "").trim();
      if (!trimmed) return "";
      const withoutPlus = trimmed.startsWith("+") ? trimmed.slice(1) : trimmed;
      return withoutPlus.replace(/\D/g, "");
    },
    buildPayload() {
      const destinations = this.parseDestinations(this.destinationsRaw)
        .map((d) => this.normalizeJelouDestination(d))
        .filter((d) => d.length > 0);
      const parameters = (this.form.parameters || [])
        .map((x) => String(x ?? "").trim())
        .filter((x) => x.length > 0);

      const payload = {
        elementName: String(this.form.elementName || "").trim(),
        destinations,
        parameters,
        type: String(this.form.type || "text").trim() || "text",
      };

      const lang = String(this.form.language || "").trim();
      if (lang) payload.language = lang;

      const mediaUrl = String(this.form.mediaUrl || "").trim();
      if (mediaUrl) payload.mediaUrl = mediaUrl;

      const filename = String(this.form.filename || "").trim();
      if (filename) payload.filename = filename;

      const campaignId = String(this.form.campaignId || "").trim();
      if (campaignId) payload.campaignId = campaignId;

      const expirationTime = String(this.form.expirationTime || "").trim();
      if (expirationTime) payload.expirationTime = expirationTime;

      return payload;
    },
    refreshPayloadPreview() {
      try {
        this.payloadPreview = JSON.stringify(this.buildPayload(), null, 2);
      } catch (e) {
        this.payloadPreview = "";
      }
    },
    resetForm() {
      this.form = this.getDefaultForm();
      this.destinationsRaw = "";
      this.endpointUrl = "";
      this.lastResult = null;
      this.refreshPayloadPreview();
    },
    addParam() {
      this.form.parameters.push("");
    },
    removeParam(idx) {
      this.form.parameters.splice(idx, 1);
    },
    async onEnviar() {
      if (this.sending) return;

      const payload = this.buildPayload();
      this.payloadPreview = JSON.stringify(payload, null, 2);

      if (!payload.elementName) {
        if (this.$toast) {
          this.$toast.warning("Indica elementName.", { position: "top-right", max: 3 });
        }
        return;
      }
      if (!payload.destinations.length) {
        if (this.$toast) {
          this.$toast.warning("Indica al menos un destino.", { position: "top-right", max: 3 });
        }
        return;
      }

      const url = (this.endpointUrl || "").trim() || this.defaultJelouUrl;

      this.sending = true;
      this.lastResult = null;
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const text = await res.text();
        let body = text;
        try {
          body = JSON.stringify(JSON.parse(text), null, 2);
        } catch (_) {
          /* no JSON */
        }
        this.lastResult = { ok: res.ok, status: res.status, body };

        if (this.$toast) {
          if (res.ok) {
            this.$toast.success("Solicitud enviada. Revisa la respuesta abajo.", {
              position: "top-right",
              max: 3,
            });
          } else {
            this.$toast.error(`Error HTTP ${res.status}. Revisa la respuesta abajo.`, {
              position: "top-right",
              max: 3,
            });
          }
        }
      } catch (e) {
        this.lastResult = {
          ok: false,
          status: 0,
          body: e?.message || String(e),
        };
        if (this.$toast) {
          this.$toast.error("No se pudo enviar (red/CORS).", { position: "top-right", max: 3 });
        }
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
.form-label {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 600;
}
.jelou-logo {
  border-radius: 10px;
  object-fit: contain;
}
</style>
